import { useState, useEffect } from "react";
import { CurrencyFormat } from "../../../utils";
import useConfiguratorData from "../../hooks/useConfiguratorData";
import ModalWrapper from "./ModalWrapper";

const ModalMaintenancePlans = ({ isOpen, onCloseModal }) => {
    const {
        getPrepaidMaintenancePlans,
        getSelectedPrepaidMaintenancePlan,
        setSelectedPrepaidMaintenancePlan,
    } = useConfiguratorData();

    const [selectedPlan, setSelectedPlan] = useState(null);
    const prepaidMaintenancePlans = getPrepaidMaintenancePlans();
    const currentSelectedPlan = getSelectedPrepaidMaintenancePlan();

    useEffect(() => {
        if (isOpen) {
            setSelectedPlan(currentSelectedPlan);
        }
    }, [isOpen, currentSelectedPlan]);

    const handlePlanSelect = (plan) => {
        if (dataLayer) {
            dataLayer.push({
                'event': 'cotizador',
                'eventCategory': 'mas_opciones',
                'eventAction': 'cta',
                'eventLabel': 'mantenciones_prepagadas'
            });
        }
        if (selectedPlan?.id === plan.id) {
            setSelectedPlan(null);
        } else {
            setSelectedPlan(plan);
        }
    };

    const handleSave = () => {
        setSelectedPrepaidMaintenancePlan(selectedPlan);
        onCloseModal();
    };

    const handleCancel = () => {
        setSelectedPlan(currentSelectedPlan);
        onCloseModal();
    };

    return (
        <ModalWrapper isOpen={isOpen} cssClass="modal-maintenance-plans">
            <div className="modal-box">
                <div className="modal-header">
                    <div className="modal-title">
                        <h1>Mantenciones Prepagadas</h1>
                        <p>Selecciona el plan que mejor se adapte a tus necesidades</p>
                    </div>
                    <button className="close-button" onClick={handleCancel}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                </div>

                <div className="modal-body">
                    <div className="maintenance-plans-list">
                        {prepaidMaintenancePlans && prepaidMaintenancePlans.length > 0 ? (
                            prepaidMaintenancePlans.map((plan) => (
                                <div
                                    key={plan.id}
                                    className={`maintenance-plan-item ${
                                        selectedPlan?.id === plan.id ? "selected" : ""
                                    }`}
                                    onClick={() => handlePlanSelect(plan)}
                                >
                                    <div className="plan-info">
                                        <h3 className="plan-name">{plan.name}</h3>
                                        {plan.description && (
                                            <p className="plan-description">{plan.description}</p>
                                        )}
                                        <div className="plan-details">
                                            {plan.months && (
                                                <span className="plan-months">
                                                    {plan.months} meses
                                                </span>
                                            )}
                                            {plan.services_count && (
                                                <span className="plan-services">
                                                    {plan.services_count} servicios incluidos
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                    <div className="plan-price">
                                        <span className="price">{CurrencyFormat(plan.price)}</span>
                                        {plan.original_price && plan.original_price > plan.price && (
                                            <span className="original-price">
                                                {CurrencyFormat(plan.original_price)}
                                            </span>
                                        )}
                                    </div>
                                    <div className="selection-indicator">
                                        {selectedPlan?.id === plan.id ? (
                                            <div className="check-circle">✓</div>
                                        ) : (
                                            <div className="empty-circle"></div>
                                        )}
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="no-plans">
                                <p>No hay planes de mantenciones disponibles para este vehículo.</p>
                            </div>
                        )}
                    </div>
                </div>

                <div className="modal-footer">
                    <button className="btn secondary" onClick={handleCancel}>
                        Cancelar
                    </button>
                    <button className="btn primary" onClick={handleSave}>
                        {selectedPlan ? "Agregar Plan" : "Quitar Plan"}
                    </button>
                </div>
            </div>
        </ModalWrapper>
    );
};

export default ModalMaintenancePlans;